import React, { useState, useRef, useEffect } from "react";
import { FiChevronDown, FiCheck } from "react-icons/fi";

const CustomSelect = ({ label, value, onChange, options, placeholder, getOptionLabel, getOptionValue }) => {
  const [isOpen, setIsOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const selectedOption = options.find(
    (opt) => (getOptionValue ? getOptionValue(opt) : opt.id) == value
  );

  return (
    <div className="relative" ref={containerRef}>
      {label && (
        <label className="block text-xs font-bold text-zinc-700 mb-1">
          {label}
        </label>
      )}
      
      {/* Trigger Button */}
      <button
        type="button"
        onClick={() => setIsOpen((prev) => !prev)}
        className="w-full flex items-center justify-between px-3 py-2 bg-zinc-50 border border-zinc-200/80 rounded-lg text-xs text-zinc-800 focus:outline-none focus:border-zinc-400 transition-colors cursor-pointer"
      >
        <span className={selectedOption ? "text-zinc-800" : "text-zinc-400"}>
          {selectedOption
            ? getOptionLabel
              ? getOptionLabel(selectedOption)
              : selectedOption.name
            : placeholder}
        </span>
        <FiChevronDown className={`w-3.5 h-3.5 text-zinc-400 transition-transform ${isOpen ? "rotate-180" : ""}`} />
      </button>

      {/* Floating Menu */}
      {isOpen && (
        <ul className="absolute z-[10000] mt-1 w-full max-h-48 overflow-auto rounded-lg bg-white p-1 border border-zinc-200 shadow-lg text-xs scrollbar-thin">
          {options.length === 0 ? (
            <li className="px-3 py-2 text-zinc-400 text-center">No options available</li>
          ) : (
            options.map((opt) => {
              const optVal = getOptionValue ? getOptionValue(opt) : opt.id;
              const optLabel = getOptionLabel ? getOptionLabel(opt) : opt.name;
              const isSelected = optVal == value;

              return (
                <li
                  key={optVal}
                  onClick={() => {
                    onChange(optVal);
                    setIsOpen(false);
                  }}
                  className={`flex items-center justify-between px-3 py-1.5 rounded-md cursor-pointer transition-colors ${
                    isSelected
                      ? "bg-zinc-100 text-zinc-900 font-medium"
                      : "text-zinc-700 hover:bg-zinc-50 hover:text-zinc-900"
                  }`}
                >
                  <span>{optLabel}</span>
                  {isSelected && <FiCheck className="w-3.5 h-3.5 text-zinc-900" />}
                </li>
              );
            })
          )}
        </ul>
      )}
    </div>
  );
};

export default CustomSelect;